// Generated by CoffeeScript 2.7.0
var PushSetting;

import PushAgent from 'trunks/vue/admin/components/push_agent.js';

import Popover from 'trunks/vue/admin/components/libs/popover.js';

import UserBoundary from 'trunks/vue/admin/components/user_boundary.js';

import UserBoundaryModel from 'app/models/user_boundary.js';

export default PushSetting = {
  components: {
    popover: Popover,
    user_boundary: UserBoundary,
    push_agent: PushAgent
  },
  props: {
    messageType: {
      type: String,
      default: 'post'
    },
    initailUserBoundary: Object,
    initailPushAgent: Object
  },
  data: function() {
    return {
      historyBoundaries: [],
      userBoundary: this.initailUserBoundary || new UserBoundaryModel({}),
      pushAgent: this.initailPushAgent || {}
    };
  },
  template: `<div class="receipt-setting">
  <div class="tab-section">
    <div class="justify-between">
      <h4 class="tab-section-title">接收范围</h4>
      <popover position='bottom right' :caret='false' ref='historyBoundaryPopover'>
        <template slot='trigger'>
          <button class='btn-small outlined btn-default text-normal'>
            <span>历史范围</span>
            <i class="slp-caret-down text-small"></i>
          </button>
        </template>
        <template slot='content'>
          <div class="history-user-boundaries">
            <div class="history-user-boundary"
                 v-for='ub in historyBoundaries'
                 :key='ub.id'
                 @click='selectHistoryUserBoundary(ub.user_boundary)'>
              <h5 class='target-title'>{{ ub.title }}</h5>
              <div class="content justify-between">
                <div class="history-user-boundary-range force-no-wrap" v-if='ub.user_boundary.organizations.length'>
                  <span class='placeholder'>范围:</span>
                  <span class="chip"><span class='text-ellipsis'>{{ ub.user_boundary.organizations[0].name }}</span></span>
                  <span v-if='ub.user_boundary.organizations_count > 1' class='placeholder'>等{{ ub.user_boundary.organizations_count }}个组织</span>
                </div>
                <div class="history-user-boundary-tag force-no-wrap" v-if='ub.user_boundary.user_tags.length'>
                  <span class='placeholder'>标签:</span>
                  <span class="chip"><span class='text-ellipsis'>{{ ub.user_boundary.user_tags[0].name }}</span></span>
                  <span class='placeholder' v-if='ub.user_boundary.user_tag_ids.length > 1'>等{{ ub.user_boundary.user_tag_ids.length }}个标签</span>
                </div>
              </div>
            </div>
          </div>
        </template>
      </popover>
    </div>
    <div class="tab-section-content">
      <user_boundary :userBoundary='userBoundary'
                     ref='userBoundary'
                     @valueChanged='updateUserBoundary' />
    </div>
  </div>
  <div class="tab-section">
    <h4 class="tab-section-title">推送</h4>
    <div class="tab-section-content">
      <push_agent @valueChanged='updatePushAgent' :push='pushAgent' />
    </div>
  </div>
</div>`,
  created: function() {
    return this.getHistoryBoundaries();
  },
  methods: {
    getHistoryBoundaries: function() {
      return Skylark.Libs.Ajax.get(Skylark.Helpers.UrlHelper.adminUrlFor(`messages/history.json?type=${this.messageType}`), {
        contentType: 'application/json; charset=utf-8',
        responseType: 'json'
      }).done((ubs, state, xhr) => {
        return this.historyBoundaries = _.map(ubs, function(ub) {
          ub.user_boundary = new UserBoundaryModel(ub.user_boundary);
          return ub;
        });
      });
    },
    getData: function() {
      return {
        user_boundary: this.userBoundary,
        push_agent: this.pushAgent
      };
    },
    selectHistoryUserBoundary: function(ub) {
      this.$refs.historyBoundaryPopover.close();
      return this._updateUserBoundary(ub);
    },
    updateUserBoundary: function(ub_vm) {
      this.userBoundary = new UserBoundaryModel(ub_vm.getData());
      return this.$emit('userBoundaryChanged', this.userBoundary);
    },
    updatePushAgent: function(push_agent) {
      return this.pushAgent = push_agent;
    },
    _updateUserBoundary: function(ub) {
      this.userBoundary = ub;
      return this.$refs.userBoundary.setUserBoundary(ub);
    }
  }
};
